import PropTypes from 'prop-types'
import {
  Popover as PopoverBase,
  Text,
  Stack,
  Inline,
  Icon
} from '@leroy-merlin-br/backyard-react-ui'
import { Checkmark, InfoCircle } from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

function Popover ({ children, list, info, ...props }) {
  return (
    <Inline align="center" justify="left" spacing="byte">
      {children}
      <PopoverBase
        title={list.title}
        content={
          <Stack spacing="byte">
            {list.items.map(item => (
              <Inline
                key={item}
                align="center"
                justify="left"
                spacing="byte"
                noWrap
              >
                <Icon as={Checkmark} size="kilo" color="green" />
                <Text size="kilo" noMargin>
                  {item}
                </Text>
              </Inline>
            ))}

            {info && (
              <Stack spacing="byte">
                <S.Divider />

                <S.TextInfo size="kilo" noMargin>
                  {info}
                </S.TextInfo>
              </Stack>
            )}
          </Stack>
        }
        placement="right-start"
        {...props}
      >
        <S.WrapperIcon>
          <Icon as={InfoCircle} color="green" />
        </S.WrapperIcon>
      </PopoverBase>
    </Inline>
  )
}

Popover.propTypes = {
  list: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.node)
    ])
  }).isRequired,
  info: PropTypes.string
}

export default Popover
